import { render, staticRenderFns } from "./topupLeaderboard.vue?vue&type=template&id=5e6523ea&"
import script from "./topupLeaderboard.vue?vue&type=script&lang=js&"
export * from "./topupLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./topupLeaderboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6523ea')) {
      api.createRecord('5e6523ea', component.options)
    } else {
      api.reload('5e6523ea', component.options)
    }
    module.hot.accept("./topupLeaderboard.vue?vue&type=template&id=5e6523ea&", function () {
      api.rerender('5e6523ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/topupLeaderboard.vue"
export default component.exports